import { twMerge } from 'tailwind-merge';
import { useTranslation } from 'react-i18next';

import ConditionalRenderer from './ConditionalRenderer';
import { UserTypeEnum } from '@/models/User';
import ComponentGuard from './ComponentGuard';
import { Tooltip } from './dataDisplay/Tooltip';
import Tag from './dataDisplay/Tag';
import { StudentTypeEnum } from '@/enums/StudentTypeEnum';
import { KlassTypeEnum } from '@/models/Klass';

type StudentConectaTagProps = {
  studentType?: StudentTypeEnum;
  className?: string;
};

export function StudentConectaTag({
  studentType,
  className,
}: StudentConectaTagProps) {
  const { t } = useTranslation('translation', {
    keyPrefix: 'studentType',
  });

  const studentConectaTypes = [
    StudentTypeEnum.CONECTA_EXTERNAL,
    StudentTypeEnum.CONECTA_INTERNAL,
  ];

  const render = !!studentType && studentConectaTypes.includes(studentType);

  const styles: Partial<Record<StudentTypeEnum, string>> = {
    [StudentTypeEnum.CONECTA_INTERNAL]: 'bg-primary',
    [StudentTypeEnum.CONECTA_EXTERNAL]: 'bg-secondary',
  };

  const tooltipText = studentType ? t(studentType) : 'Conecta';

  return (
    <ConditionalRenderer condition={render}>
      <ComponentGuard
        roles={[
          UserTypeEnum.SUPER_ADMIN,
          UserTypeEnum.UNIT_ADMIN,
          UserTypeEnum.TEACHER,
        ]}
      >
        <Tooltip text={tooltipText}>
          <Tag
            color="custom"
            text="C"
            className={{
              base: twMerge(
                'py-0.5 px-1 text-base-100 aspect-square',
                styles[studentType ?? StudentTypeEnum.CONECTA_EXTERNAL],
                className,
              ),
            }}
          />
        </Tooltip>
      </ComponentGuard>
    </ConditionalRenderer>
  );
}

type KlassConectaTagProps = {
  klassType: KlassTypeEnum;
};

export function KlassConectaTag({ klassType }: KlassConectaTagProps) {
  const render = klassType === KlassTypeEnum.CONECTA;

  return (
    <ConditionalRenderer condition={render}>
      <ComponentGuard
        roles={[
          UserTypeEnum.SUPER_ADMIN,
          UserTypeEnum.UNIT_ADMIN,
          UserTypeEnum.TEACHER,
        ]}
      >
        <Tooltip text="Conecta" classNameContainer="flex h-full p-0">
          <Tag
            color="custom"
            text="C"
            className={{
              base: 'py-0.5 px-1 bg-secondary text-base-100 aspect-square',
            }}
          />
        </Tooltip>
      </ComponentGuard>
    </ConditionalRenderer>
  );
}
